<template>
  <div id="thisOrThatThree"></div>
</template>

<script>
export default {
  name: "ThisOrThatThree",
  props: {
    data: {
      type: Object,
      required: true,
      default: () => ({
        question: "Which do you prefer?",
        optionA: "Remote Work",
        optionB: "Office Work",
        chip: "This or That",
      }),
    },
    scale: {
      type: Number,
      required: true,
      default: 0.8,
    },
  },
  computed: {
    workspace() {
      return this.$store.state.workspace;
    },
  },
  mounted() {
    this.render();
  },
  watch: {
    scale: {
      handler() {
        this.render();
      },
      immediate: true,
      deep: true,
    },
    data: {
      handler() {
        this.render();
      },
      deep: true,
    },
  },
  methods: {
    render() {
      const el = document.getElementById("thisOrThatThree");
      if (!el) return;
      el.innerHTML = this.exportHTML();
    },
    exportHTML(exporting = false) {
      const containerSize = exporting ? 1200 : 1200 * this.scale;
      const questionSize = exporting ? 34 : 34 * this.scale;
      const optionSize = exporting ? 54 : 54 * this.scale;
      const logoHeight = exporting ? 45 : 45 * this.scale;
      const chipSize = exporting ? 18 : 18 * this.scale;
      const vsSize = exporting ? 80 : 80 * this.scale;

      const logoSrc = this.workspace?.branding?.logo?.dark || "";
      const primaryColor =
        this.workspace?.branding?.color?.primary || "#e63946";

      let openingDiv = `<div style="height: ${containerSize}px; width: ${containerSize}px; aspect-ratio: 1 / 1;">`;

      let html = `
        ${openingDiv}
        <div
          style="
            background-color: #fafafa;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            height: 100%;
            width: 100%;
            aspect-ratio: 1 / 1;
            position: relative;
            overflow: hidden;
          "
        >
          <!-- Giant VS in background -->
          <div style="
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            font-size: ${vsSize * 3}px;
            font-family: 'Playfair Display', 'Georgia', serif;
            font-weight: 900;
            color: #000000;
            opacity: 0.03;
            pointer-events: none;
          ">VS</div>

          <!-- Header with logo -->
          <div style="padding: 8%; position: relative; z-index: 1;">
            <img src="${logoSrc}" height="${logoHeight}px" alt="" />
          </div>

          <!-- Content -->
          <div style="padding: 0 8% 8% 8%; position: relative; z-index: 1;">
            <div style="
              font-size: ${questionSize}px;
              font-weight: 500;
              color: #666666;
              text-align: center;
              margin-bottom: 48px;
              font-family: 'Inter', 'Helvetica Neue', sans-serif;
            ">${this.data.question}</div>

            <div style="display: flex; gap: 24px;">
              <!-- Option A -->
              <div style="
                flex: 1;
                background: #ffffff;
                border-radius: 12px;
                padding: 48px 24px;
                text-align: center;
                box-shadow: 0 4px 20px rgba(0,0,0,0.08);
              ">
                <div style="
                  font-size: ${optionSize}px;
                  font-family: 'Playfair Display', 'Georgia', serif;
                  font-weight: 700;
                  color: #1a1a1a;
                  line-height: 1.2;
                  margin-bottom: 16px;
                ">${this.data.optionA}</div>
                <div style="
                  width: 60px;
                  height: 4px;
                  background: ${primaryColor};
                  margin: 0 auto;
                "></div>
              </div>

              <!-- VS Divider -->
              <div style="
                display: flex;
                align-items: center;
                font-size: ${vsSize}px;
                font-weight: 900;
                color: #1a1a1a;
                opacity: 0.15;
              ">VS</div>

              <!-- Option B -->
              <div style="
                flex: 1;
                background: #1a1a1a;
                border-radius: 12px;
                padding: 48px 24px;
                text-align: center;
              ">
                <div style="
                  font-size: ${optionSize}px;
                  font-family: 'Playfair Display', 'Georgia', serif;
                  font-weight: 700;
                  color: #ffffff;
                  line-height: 1.2;
                  margin-bottom: 16px;
                ">${this.data.optionB}</div>
                <div style="
                  width: 60px;
                  height: 4px;
                  background: ${primaryColor};
                  margin: 0 auto;
                "></div>
              </div>
            </div>

            <!-- Chip -->
            <div style="display: flex; justify-content: center; margin-top: 40px;">
              <span
                style="
                  display: inline-block;
                  background: #1a1a1a;
                  color: #ffffff;
                  font-size: ${chipSize}px;
                  font-weight: 600;
                  border-radius: 4px;
                  padding: 12px 20px;
                  letter-spacing: 0.08em;
                  text-transform: uppercase;
                  font-family: 'Inter', 'Helvetica Neue', sans-serif;
                "
              >
                ${this.data.chip}
              </span>
            </div>
          </div>
        </div>
      </div>
      `;

      return html;
    },
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Playfair+Display:wght@600;700;900&display=swap");
</style>
